import axios from '../../axios';
import { GetInvoicesDto } from '../../../models/dtos/getInvoices.dto';

export default async function getInvoicesRepository(
  ids: any,
  journalType?: string[]
): Promise<GetInvoicesDto[]> {
  const res = await axios.get<GetInvoicesDto[]>(
    `${process.env.REACT_APP_BASE_URL}/invoice`,
    {
      params: {
        invoiceTypeId: ids?.join(','),
        journalType: journalType?.join(','),
      },
    }
  );
  return res.data;
}




